import firebase from "firebase/app";
import 'firebase/auth';
import 'firebase/firestore';

var firebaseConfig = {
    apiKey: "AIzaSyCuEOLXtFMf1gWNvP1WjbJC_kf_ryrViAY",
    authDomain: "dennisrankin-444.firebaseapp.com",
    databaseURL: "https://dennisrankin-444.firebaseio.com",
    projectId: "dennisrankin-444",
    storageBucket: "dennisrankin-444.appspot.com",
    messagingSenderId: "262754007253",
    appId: "1:262754007253:web:6b81f5f8f9483f02358a5c",
    measurementId: "G-CHECVY73NY"
};

firebase.initializeApp(firebaseConfig)

const db = firebase.firestore()
const auth = firebase.auth()


if (window.location.hostname === "localhost") {
    // eslint-disable-next-line no-console
    console.log("localhost detected!");
    db.settings({
        host: "localhost:8080",
        ssl: false
    });
    auth.useEmulator("http://localhost:9099");
}
const subscribersCollection = db.collection("Subscribers")

export {
    db,
    auth,
    subscribersCollection
}
